<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="searchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-3">
                <label class="col-md-4">學年</label>
                <div class="col-md-8">
                  <select v-model="query.schYear" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(item, index) in schoolYearList" :key="index" :value="item">{{ item }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">學期</label>
                <div class="col-md-8">
                  <select v-model="query.smtr" class="form-control">
                    <option value="">--請選擇--</option>
                    <option value="1">第一學期</option>
                    <option value="2">第二學期</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">學號</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.stuAccount" />
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">姓名</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.stuName" />
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-6">
                <label class="col-md-2">區域</label>
                <div class="col-md-10">
                  <input type="text" class="form-control" v-model="query.mageArea" placeholder="例: 高爾夫宿舍-19樓" />
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-offset-4 col-md-4">
              <div class="col-md-offset-4 col-md-4">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="tab-content">
      <div class="row form-group">
        <div class="col-md-12 text-right form-inline">
          <label for="reserveMageExcel">
            <div style="display:none;">
              <input type="file" id="reserveMageExcel" name="reserveMageExcel" @change="impReserveMageRoster($event)" />
            </div>
            <a class="btn btn-danger">資料匯入</a>
            <a href="javascript:;" target="_blank" class="btn btn-danger" @click="downloadFile('儲備幹部匯入範本.xlsx')">儲備幹部匯入範本</a>
          </label>
        </div>
      </div>

      <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="reserve-mage-tab">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="8%">序號</th>
                  <th class="text-center" width="12%">學年</th>
                  <th class="text-center" width="10%">學期</th>
                  <th class="text-center" width="15%">學號</th>
                  <th class="text-center" width="12%">姓名</th>
                  <th class="text-center" width="28%">幹部所屬區域</th>
                  <th class="text-center" width="15%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in reserveMageGrid" :key="index">
                  <td class="text-center" data-title="序號">{{ (page - 1) * pageSize + index + 1 }}</td>
                  <td class="text-center" data-title="學年">{{ item.schYear }}</td>
                  <td class="text-center" data-title="學期">{{ item.smtr }}</td>
                  <td class="text-center" data-title="學號">{{ item.stuAccount }}</td>
                  <td class="text-center" data-title="姓名">{{ item.stuName }}</td>
                  <td class="text-center" data-title="幹部所屬區域">{{ item.mageArea }}</td>
                  <td class="text-center" data-title="">
                    <a class="btn btn-link" @click="delReserveMage(item)">刪除</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center" v-if="isAdmin('stay')">
              <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reserveMageGrid: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      query: {
        schYear: "",
        smtr: "",
        stuAccount: "",
        stuName: "",
        mageArea: ""
      }
    };
  },
  computed: {
    schoolYearList() {
      const now = new Date();
      let year = now.getFullYear() - 1911;
      if (now.getMonth() + 1 < 8) {
        year -= 1;
      }
      const list = [];
      for (let y = year; y > 111; y--) {
        list.push(String(y));
      }
      return list;
    }
  },
  mounted() {
    if (this.sessionData == null) {
      this.$router.replace({ path: "/" });
      return;
    }
    this.pageInit();
  },
  methods: {
    updateGrid(page) {
      this.page = page;
      this.pageInit();
    },
    pageInit() {
      const api = "/api/RoomMage/reserveMageGrid";
      const param = {
        page: this.page,
        pageSize: this.pageSize,
        model: this.query
      };
      this.$axios.post(api, JSON.stringify(param)).then(resp => {
        this.reserveMageGrid = resp.data.data.rows || [];
        this.totalPage = resp.data.data.total;
      });
    },
    impReserveMageRoster(e) {
      const api = "/api/RoomMage/impReserveMageRoster";
      if (e.target.files.length > 0) {
        const excelFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file", excelFile);
        this.$axios.post(api, formData).then(resp => {
          bootbox.alert(resp.data.msg.replace(new RegExp(/\r?\n/, "g"), "<br />"), () => {
            if (resp.data.status === "success") {
              this.pageInit();
            }
          });
        });
        e.target.value = "";
      }
    },
    delReserveMage(item) {
      bootbox.confirm("確定刪除此筆?", result => {
        if (!result) {
          return;
        }
        const api = `/api/RoomMage/delReserveMage/${item.schYear}/${item.smtr}/${item.stuAccount}`;
        this.$axios.delete(api).then(resp => {
          bootbox.alert(resp.data.msg, () => {
            if (resp.data.status === "success") {
              this.pageInit();
            }
          });
        });
      });
    }
  }
};
</script>
